/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, Drawer, IconButton, Step, StepLabel, Stepper, styled, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { LoadingPage } from "../../../../common/LoadingPage";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { useSelector } from "react-redux";
import CommonDestination from "./CommonDestination";
import { apiRequest } from "../../../../common/common";
import { useState } from "react";
import Templates from "../../Templates/templates";

const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 5px 5px 15px'
}));

const steps = ['Template(s)', 'Destination(s)'];

const CreateItemFromTemplate = ({
    templateOpen,
    setTemplateOpen,
    projectData,
    room,
    level,
    department,
    innerLabel,
    onGridReady
}) => {
    const { user } = useSelector(state => state.users);
    const [dataLoading, setDataLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [item, setItem] = useState({
        organization_id: user?.organization?.organization_id,
    });
    const [tableData, setTableData] = useState([]);

    const handleClose = () => {
        setTemplateOpen(false);
        setItem(null);
        setActiveStep(0);
        setSelectedProduct([]);
    }

    const handleSubmit = async () => {
        if (tableData?.length > 0) {
            setDataLoading(true);
            try {
                if (innerLabel === 'Department') {
                    item.template_ids = selectedProduct;
                    item.level_ids = tableData.map((a) => a.level_id);
                    const response = await apiRequest('post', '/department/create-from-template', item);
                    if (response.data) {
                        handleClose();
                        onGridReady();
                        showNotification(response.data.message, 'success');
                    }
                } else if (innerLabel === 'Room') {
                    item.room_template_ids = selectedProduct;
                    item.department_ids = tableData.map((a) => a.department_id);
                    const response = await apiRequest('post', '/project-room/create-from-template', item);
                    if (response.data) {
                        handleClose();
                        onGridReady();
                        showNotification(response.data.message, 'success');
                    }
                } else {
                    item.item_template_ids = selectedProduct;
                    item.project_id = projectData.project_id;
                    item.room_data = JSON.stringify(
                        tableData?.map((a) => ({
                            room_id: a.room_id,
                            quantity: a.quantity || 1
                        }))
                    );
                    const response = await apiRequest('post', '/project-item/from-template', item);
                    if (response.data) {
                        handleClose();
                        onGridReady();
                        showNotification(response.data.message, 'success');
                    }
                }
            } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        } else {
            showNotification('Please select destination before proceed', 'error');
        }
    }

    const handleNext = () => {
        if (activeStep === 0 && selectedProduct.length === 0) {
            if (innerLabel === 'Department') {
                showNotification('Please select department', 'error');
            } else if (innerLabel === 'Room') {
                showNotification('Please select room', 'error');
            } else {
                showNotification('Please select item', 'error');
            }
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    const handleBack = () => {
        setSelectedProduct([]);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    return (
        <Drawer
            anchor="bottom"
            open={templateOpen}
            sx={{
                '& .MuiDrawer-paper': {
                    height: '88%',
                }
            }}
        >
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <DemoBox1>
                <Typography variant='body1' style={{ fontWeight: 'bold' }}>Add Item(s) From Template</Typography>
                <Box>
                    {activeStep > 0 && (
                        <Button variant='outlined' size="small" onClick={() => handleBack()} style={{ marginRight: 5 }}>
                            Back
                        </Button>
                    )}
                    {activeStep < 1 && (
                        <Button variant='contained' size="small" onClick={() => handleNext()}>
                            Next
                        </Button>
                    )}
                    {activeStep === 1 && (
                        <Button variant='contained' size="small" onClick={() => handleSubmit()}>
                            Save
                        </Button>
                    )}
                    <IconButton onClick={() => handleClose()}>
                        <ClearIcon />
                    </IconButton>
                </Box>
            </DemoBox1>
            <Divider />
            <Box sx={{ width: '100%', padding: '5px 0px 0px 0px' }}>
                <Stepper activeStep={activeStep} style={{ marginBottom: '5px' }}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <Divider />
            </Box>
            {activeStep === 0 && (
                <Templates
                    fromProject={true}
                    setSelectedProduct={setSelectedProduct}
                    innerLabel={innerLabel}
                />
            )}
            {activeStep === 1 && (
                <CommonDestination
                    projectData={projectData}
                    room={room}
                    level={level}
                    department={department}
                    tableData={tableData}
                    setTableData={setTableData}
                    innerLabel={innerLabel}
                />
            )}
        </Drawer>
    )
}

export default CreateItemFromTemplate;